import { Link, Navigate, useParams } from "react-router-dom";
import { VENDOR_GROUPS, getVisibility, labelFor, listVendors } from "@hub";
import { useHubVisitor, withVisitor } from "../hubContext";

export default function VendorDetail() {
  const { id } = useParams();
  const visitor = useHubVisitor();
  const visibility = getVisibility();
  const vendor = listVendors().find((item) => item.id === id);
  if (!vendor) return <Navigate to={withVisitor("/vendors", visitor)} replace />;
  if (visibility.vendors === false) {
    return (
      <article>
        <h1>Vendor</h1>
        <p className="lead">This directory is hidden for now.</p>
      </article>
    );
  }
  const groups = VENDOR_GROUPS[vendor.audience] || [];
  const listPath = vendor.audience === "pro" ? "/vendors/pro" : "/vendors/client";

  return (
    <article>
      <p className="muted">
        <Link to={withVisitor("/vendors", visitor)}>Vendor hub</Link>
        {" · "}
        <Link to={withVisitor(listPath, visitor)}>{vendor.audience === "pro" ? "Pro directory" : "Client directory"}</Link>
      </p>
      <h1>{vendor.name}</h1>
      <p className="lead">{vendor.summary}</p>
      <div className="card-grid">
        <section className="card">
          <h2>Directory</h2>
          <p>{vendor.audience === "pro" ? "Real estate pros" : "Client support"}</p>
          <p>{labelFor(groups, vendor.group)}</p>
        </section>
        <section className="card">
          <h2>Region</h2>
          <p>{vendor.region || "San Diego County"}</p>
          <p className="muted">Southern California is the next expansion.</p>
        </section>
        <section className="card">
          <h2>Contact</h2>
          {vendor.url ? (
            <p>
              <a href={vendor.url} target="_blank" rel="noreferrer">
                Visit site
              </a>
            </p>
          ) : (
            <p className="placeholder-note">Link placeholder. Offices add a URL from Admin Controls.</p>
          )}
        </section>
      </div>
      <section className="card placeholder-frame">
        <h2>How to use this listing</h2>
        <p>
          DreamHome Journey is not a marketplace. Confirm insurance, licensing, and office policy
          with your agent or broker before you hire anyone. This card is a companion note.
        </p>
      </section>
    </article>
  );
}
